import M from 'backbone.marionette'
import T from './loading.html'
export const Loading = M.View.extend({
    template: _.template(T)
})
